import { convertFeatureCollectionToGeozoneArray, findGeozonesFromFeatures, } from '../utils/custom-feature-utils';
export const createGeozoneFromServer = (added_geozone) => ({
    type: 'CREATE_GEOZONE_FROM_SERVER',
    added_geozone,
});
export const createGeozone = (geozone_from_client) => async (dispatch, getState, { api }) => {
    //Отправляем на сервер
    try {
        const { geozone_id, user_id, geozone } = await api.create_geozone(geozone_from_client);
        //Отправляю в topUpDialogReducer
        dispatch({
            type: 'CREATE_GEOZONE',
            geozone: geozone.geojson,
            geozone_id,
            user_id,
        });
    }
    catch ({ json }) {
        const message = json?.error_ui ?? 'Не удалось сохранить геозону';
        alert(message);
    }
};
export const deleteGeozonesFromServer = (geozone_id) => ({
    type: 'DELETE_GEOZONES_FROM_SERVER',
    geozone_id,
});
export const deleteGeozones = (geozones) => async (dispatch, getState, { api }) => {
    //Возможно прямо здесь надо превратить FeatureCollection в массив GeoJSON
    const deleteGeoJSON = convertFeatureCollectionToGeozoneArray(geozones);
    if (deleteGeoJSON == null)
        return;
    //И перед тем, как отправлять на сервер, их надо привести к виду, как хранятся в БД - тип Geozone
    const geozones_for_delete = findGeozonesFromFeatures(deleteGeoJSON, getState().geozones);
    if (geozones_for_delete == null)
        return;
    //Делаем изменения в Redux
    dispatch({ type: 'DELETE_GEOZONES', geozones: geozones_for_delete });
    //Отправляем команду на сервер, что надо удалить из БД
    await api.delete_geozones(geozones_for_delete);
};
export const deleteGeozoneFromList = (geozone) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'DELETE_GEOZONES', geozones: [geozone] });
    await api.delete_geozones([geozone]);
};
export const updateGeozonesFromOldProgram = (all_geozones) => ({
    type: 'UPDATE_GEOZONES_FROM_OLD_PROGRAM',
    all_geozones,
});
export const updateGeozonesFromServer = (updated_geozones) => ({
    type: 'UPDATE_GEOZONES_FROM_SERVER',
    updated_geozones,
});
async function asyncUpdateGeozones(api, geozones) {
    await api.update_geozones(geozones);
}
export const editGeozones = (geozones) => async (dispatch, getState, { api }) => {
    const edited_GeoJSON = convertFeatureCollectionToGeozoneArray(geozones);
    if (edited_GeoJSON == null)
        return;
    const geozones_for_edit = findGeozonesFromFeatures(edited_GeoJSON, getState().geozones);
    if (geozones_for_edit == null)
        return;
    dispatch({ type: 'EDIT_GEOZONES', geozones: geozones_for_edit });
    await asyncUpdateGeozones(api, geozones_for_edit);
};
export const editGeozoneProperties = (geozone) => async (dispatch, getState, { api }) => {
    dispatch({ type: 'EDIT_GEOZONES', geozones: [geozone] });
    await asyncUpdateGeozones(api, [geozone]);
};
export const geozones_attachment_set_message_action = (content) => ({ type: 'GEOZONES_ATTACHMENT_SET_MESSAGE', content });
export const is_loading_upload_geozones_action = (is_loading) => ({ type: 'IS_LOADING_UPLOAD_GEOZONES', is_loading });
export const upload_geozones_from_file_action = (files) => async (dispatch, getState, { api }) => {
    if (!FormData) {
        dispatch(geozones_attachment_set_message_action({
            title: 'Неподдерживаемый браузер',
            message: 'Загрузка файлов не поддерживается в вашем браузере. Воспользуйтесь Chrome, Firefox, Opera 12+ или Internet Explorer 10+',
        }));
        return;
    }
    if (files == null || files.length === 0)
        dispatch(geozones_attachment_set_message_action({
            title: 'Нет файла для загрузки',
            message: 'Выберите файл для загрузки',
        }));
    try {
        dispatch(is_loading_upload_geozones_action(true));
        const { user_id, geozones_arr } = await api.upload_geozones(files);
        dispatch({ type: 'UPLOAD_GEOZONES_FROM_FILE', user_id, geozones_arr });
    }
    catch (error) {
        const { json } = error;
        dispatch(geozones_attachment_set_message_action({
            title: 'Загрузка геозон не удалась',
            message: json?.error_ui ?? 'Ошибка связи с сервером',
        }));
    }
    finally {
        dispatch(is_loading_upload_geozones_action(false));
    }
};
